export default __webpack_public_path__ + "573d36a3788c4dc6c5e29d42380bb93d.png";